import { useState, useEffect } from "react";
import { Typography, Button } from "@mui/material";
import { UseDeliveryReport } from "./UseDeliveryReport";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useLocation, useNavigate } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import OrderDeliveryDetails from "./OrderDeliveryDetails";

export default function DeliveryReport(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { myPc, updatePage, updateSort, setScrollTo } = UseMyPC();
  const { GetDeliveryReport } = UseDeliveryReport();
  const [reportRes, setReportRes] = useState();
  const [progress, setProgress] = useRecoilState(rsProgress);
  var NewDate = new Date().toJSON().slice(0, 10);
  const navigate = useNavigate();

  useEffect(() => {
    setProgress(true);
    GetDeliveryReport(myPc, true, (callback) => {
      setReportRes(callback);
    });
  }, [myPc]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },
    {
      field: "dayname",
      width: 180,
      align: "center",
      headerName: "تاریخ",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "peikOrder",
      headerName: "ارسال پیک",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.peikOrder ? toMoney(cellValues.row.peikOrder) : 0}
          </Typography>
        );
      },
    },
    {
      field: "normalPeik",
      headerName: "پیک عادی",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.normalPeik ? toMoney(cellValues.row.normalPeik) : 0}
          </Typography>
        );
      },
    },
    {
      field: "expressPeik",
      headerName: "پیک اکسپرس",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.expressPeik
              ? toMoney(cellValues.row.expressPeik)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "postOrder",
      headerName: "ارسال پست",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.postOrder ? toMoney(cellValues.row.postOrder) : 0}
          </Typography>
        );
      },
    },
    {
      field: "totalOrder",
      headerName: "مجموع سفارشات",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.totalOrder ? toMoney(cellValues.row.totalOrder) : 0}
          </Typography>
        );
      },
    },
    {
      field: "جزئیات",
      sortable: false,
      width: 120,
      headerAlign: "center",
      align: "center",
      headerName: "جزئیات",
      renderCell: (cellValues) => {
        return (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              setProgress(true);
              setScrollTo(cellValues.api.getScrollPosition());
              return navigate("/deliveryreport/details", {
                state: {
                  myPc: myPc,
                  deliverydate: cellValues.row.deliverydate.split("T")[0],
                },
              });
            }}
          >
            جزئیات
          </Button>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "گزارشات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/deliveryreport" }],
      }}
    >
      {reportRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={
            reportRes && reportRes.pageCondition
              ? reportRes.pageCondition.pageCount
              : 1
          }
          rows={reportRes ? reportRes.item : []}
          paginationMode="server"
          page={
            reportRes && reportRes.pageCondition
              ? reportRes.pageCondition.page - 1
              : 1
          }
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            reportRes && reportRes.pageCondition
              ? reportRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              isLtr: true,
              nofab: true,
              rowCount:
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.totalItemCount
                  : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "&  .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "&  .MuiDataGrid-cell:focus-within ": {
              outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
            },
            "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
              {
                outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
              },
            "& .MuiDataGrid-cell:hover": {
              opacity: "80%",
              cursor: "pointer",
            },
            "& .MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !important",
            },

            "& .Green": {
              backgroundColor: "#56ff004f !important",
            },
          }}
          getRowClassName={(params) => {
            if (params.row.deliverydate.split("T")[0] == NewDate) {
              return "Green";
            }
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
